// src/firebase.js
// HomeIQa — Firebase initialization
// Replace the config values below with your actual Firebase project credentials
// Found at: Firebase Console → Project Settings → Your Apps → SDK setup

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getMessaging, isSupported as isMessagingSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Firebase Cloud Messaging — async-safe wrapper. Messaging only works on
// browsers that support the relevant APIs (modern Chrome/Firefox/Edge,
// installed PWA on iOS 16.4+). Returns null on unsupported environments.
export async function getMessagingIfSupported() {
  try {
    if (await isMessagingSupported()) return getMessaging(app);
  } catch {}
  return null;
}

// VAPID public key from Firebase Console → Project Settings →
// Cloud Messaging → Web Push certificates. Public — safe in code.
export const FIREBASE_VAPID_PUBLIC_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

// Cloud Function callable references
export const generateReport = httpsCallable(functions, 'generateReport');
export const capturePayPalOrder = httpsCallable(functions, 'capturePayPalOrder');
export const createPayPalOrder = httpsCallable(functions, 'createPayPalOrder');
export const getReportStatus = httpsCallable(functions, 'getReportStatus');
export const resendReport = httpsCallable(functions, 'resendReport');
